<template>

	<div class="topic-menu-frame">

		<LevelBlock v-for="(menu,index) in topic.menus" :key="menu" :menu="menu" :index="index"
		            :container="topic.menus" :editMode="topic.editMode"/>

		<div class="level add" @click.stop.prevent="topic.addMenu()" v-show="topic.editMode">
			<i class="fa fa-plus"></i>
			添加菜单
		</div>

	</div>
</template>

<script>
	import Topic from '../../../../common/model/topic/Topic'
	import TopicMenu from '../../../../common/model/topic/TopicMenu'
	import LevelBlock from "./LevelBlock.vue"


	export default {
		data(){
			return {}
		},
		props: {
			topic: {
				type: Topic,
				required: true
			}
		},
		components: {
			LevelBlock
		},
		computed: {},
		watch: {},
		methods: {},
		mounted(){
		}
	}
</script>

<style lang="less" rel="stylesheet/less">
	.topic-menu-frame {

		@color-bg: #F8FAFF;
		@color-bg-highlight: #F4F6F7;
		@color-border: #DAE2EA;
		@color-border-highlight: #DCE2E8;
		@color-attribute: #d9534f;
		@color-attribute-highlight: #d91903;
		@color-field: #3F6AB2;
		@color-field-highlight: #0645b2;
		@color-topic: #0cb20c;
		@color-topic-highlight: #0ab224;

		@color-collection: #b28813;
		@color-collection-highlight: #b26905;
		@color-add-btn: #999;
		@color-add-btn-highlight: #555;

		.usage {
			.indicator {

			}
			.content {
				border: 1px solid #aaaaaa;
				padding: 10px;

				.section {
					margin-top: 20px;
					&:first-child {
						margin-top: 0;
					}

				}
			}

		}
		.label-attribute {
			font-weight: bold;
			color: @color-attribute;
		}
		.label-link{
			font-weight: bold;
			color: @color-collection-highlight;
		}
		.label-topic{
			font-weight: bold;
			color: @color-topic-highlight;
		}

		.label-field {
			font-weight: bold;
			color: @color-field;
		}

		option:disabled {
			color: red;
		}

		.level-block {
			margin: 5px 0 5px 25px;
		}
		> .level-block {
			margin-left: 0;
		}

		.panel {
			margin-bottom: 0;
		}
		.panel-body {
			border-top: 1px solid #ddd;
		}
		.level, .panel-heading {

			border-color: transparent;

			&.error {
				border: 1px dashed red;
			}

			cursor: pointer;
			background: @color-bg;
			color: @color-field;

			text-decoration: none;
			font-weight: bold;
			-webkit-box-sizing: border-box;
			-moz-box-sizing: border-box;
			box-sizing: border-box;

			//添加属性按钮
			&.add {

				min-height: 38px;
				margin: 5px 0;
				padding: 8px 12px;

				text-align: center;
				border: 1px dashed @color-add-btn;
				color: @color-add-btn;
			}

			&:hover {
				color: @color-field-highlight;

				background: @color-bg-highlight;
				&.add {
					border: 1px dashed @color-add-btn-highlight;
					color: @color-add-btn-highlight;
				}
			}
		}

	}
</style>


// WEBPACK FOOTER //
// TopicMenuFrame.vue?01436760